import { createStyles, rem } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  firsttext: {
    marginTop: "40px",
    marginBottom: "8px",
    fontFamily: "Inter",
    fontSize: 13,
    fontWeight: 400,
    color: "#2F2F2F",
    cursor: "pointer",
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  clientInfo: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    "& img": {
      width: "30px",
    },
  },
  clientlogo: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    objectFit: "cover",
  },
  firstpara: {
    color: "#070707",
    fontFamily: "Inter",
    fontSize: "28px",
    fontWeight: 500,
    lineHeight: "58.09px",
    textAlign: "left",
  },

  editbtn: {
    display: "flex",
    justifyContent: "end",
    position: "relative",
    bottom: "37px",
  },

  fq0g4p: {
    borderBottom: "None",
  },

  firstbox: {
    marginTop: "37px",
    //width: '100%',
    //height: '725px',
    border: "0.5px solid #070707",
    background: "#F4F4F2",
  },

  fourthbox: {
    marginTop: "37px",
    //width: '100%',
    //height: '725px',
    border: "0.5px solid #070707",
    background: "#D8D8D8",
  },

  fifthbox: {
    background: "#F4F4F2",
    marginTop: "37px",
    //width: '100%',
    //height: '725px',
    border: "0.5px solid #070707",
  },

  newfifthbox: {
    background: "#F4F4F2",
    //marginTop: "37px",
    //width: '100%',
    //height: '725px',
    // border: '0.5px solid #070707',
  },

  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    overflowX: "clip",
    background: "#F5F5F5",
    minHeight: "100vh",
    maxHeight: "fit-content",
  },

  clientprofile: {
    color: "#070707",
    fontFamily: "Inter",
    fontSize: "20px",
    textAlign: "Center",
    paddingTop: "10px",
    paddingBottom: "10px",
    //marginTop:'12px',
    borderBottom: "0.5px solid #070707",
    fontWeight: "600",
  },

  secondbox: {
    width: "90%",
    paddingTop: "36px",
    //height: '213px',
    borderRadius: "5px",
    border: "0.5px solid #070707",
    background: "#FFF",
    marginTop: "36px",
    margin: "auto",
    paddingBottom: "38px",
  },

  id: {
    color: "#2F2F2F",
    textAlign: "center",
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "500",
    "@media (max-width: 1024px)": {
      fontSize: "12px",
      textAlign: "left",
    },
  },

  text: {
    color: "#7C7C7C",
    textAlign: "center",
    fontFamily: "Inter",
    fontSize: "16px",
    fontweight: "500",
    "@media (max-width: 1024px)": {
      fontSize: "12px",
    },
  },

  diaghead: {
    color: "#070707",
    fontFamily: "Inter",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "500",
    textAlign: "center",
  },

  diagpara: {
    color: "#7C7C7C",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "400",
    marginTop: "5px",
    textAlign: "center",
    "@media (max-width: 1024px)": {
      fontSize: "12px",
    },
    //paddingBottom:'55px'
  },

  boxtext: {
    //border: '0.5px solid #070707',
    background: "#D8D8D8",

    color: "#070707",
    fontFamily: "Inter",
    fontSize: "16px",

    paddingTop: "14px",
    paddingBottom: "13px",
    paddingLeft: "20px",
    fontWeight: "500",
  },

  boxpara: {
    //border: '0.5px solid #070707',
    paddingTop: "14px",
    paddingBottom: "13px",
    paddingLeft: "20px",
    background: "#F8F8F8",
    color: "#070707",
    fontFamily: "Inter",
    fontSize: "14px",

    fontWeight: "500",
  },

  boxnewpara: {
    border: "0.5px solid #070707",
    //paddingTop: "14px",
    //paddingBottom: "13px",
    //paddingLeft:'20px',
    // width: "20%",
    //height: '33px',
    padding: "8px 10px",
    background: "#D8D8D8",
    color: "#070707",
    fontFamily: "Inter",
    fontSize: "14px",
    textAlign: "center",
    fontWeight: "500",
    "@media (max-width: 1024px)": {
      fontSize: "12px",
    },
  },

  thirdbox: {
    width: "100%",
    margin: "auto",
    // height: '247px',
    //border: '0.5px solid #070707',
  },

  newbox: {
    // width:'90%',
    // margin:'auto',
  },

  guard: {
    padding: "9px",
    color: "070707",
    fontFamily: "Inter",
    fontSize: "15px",
    fontWeight: "500",
    paddingRight: "20px",
  },
  newname: {
    color: "070707",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: "600",
  },
  newpara: {
    color: "070707",

    fontFamily: "Inter",
    fontSize: "10px",
    fontWeight: "600",
  },
  top_header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 0",
    position: "sticky",
  },
  buttonParent: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "30px",
    "@media (max-width: 500px)": {
      display: "block",
      textAlign: "center",
      marginRight: "0",
    },
    insuranceCompParent: {
      marginLeft: "10px",
    },
  },
  tabs: {
    "& .mantine-Tabs-tabsList": {
      borderRadius: "0px 0px 8px 8px",
      backgroundColor: "#FFF",
      padding: "26px 16px 14px 16px",
      border: "none",
      overflowX: "auto",
      flexWrap: "nowrap",
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": { display: "none" },
      "& .mantine-Tabs-tab": {
        padding: "8px 16px",
        borderBottom: "2px solid #E5E5E5",
        lineHeight: "20px",
        background: "#fff",
        borderRadius: "0px",
        color: "#262626",
        fontFamily: "Inter",
        fontSize: "14px",
        fontWeight: 400,
        flexShrink: 0,
        whiteSpace: "nowrap",
        "&:hover": {
          borderColor: "none",
        },
        "&[data-active]": {
          color: "#262626 !important",
          backgroundColor: "#FFF !important",
          fontWeight: "700 !important",
          borderBottom: "2px solid #262626 !important",
        },
      },
      "& .mantine-Tabs-tab:first-of-type": {
        borderTopLeftRadius: "4px",
      },
      "& .mantine-Tabs-tab:last-of-type": {
        borderTopRightRadius: "4px",
      },
    },
    "@media (max-width: 480px)": {
      "& .mantine-Tabs-tabsList": {
        padding: "14px 12px 10px 12px",
        "& .mantine-Tabs-tab": {
          padding: "7px 11px",
          fontSize: "13px",
        },
      },
    },
  },
  profile_container: {
    borderRadius: "8px",
    backgroundColor: "#FFF",
    padding: "8px 16px 0px 16px",
  },
  tabsWrapper: {
    paddingLeft: "20px",
    paddingRight: "20px",
    color: "#262626",
    "@media (max-width: 480px)": {
      paddingLeft: "12px",
      paddingRight: "12px",
    },
    "@media (max-width: 360px)": {
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
}));

export default useStyles;
